import React, { useEffect, useState } from 'react';
import { Button } from '@material-ui/core';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { makeStyles } from '@material-ui/core/styles';
import { PRIMARY_COLOR } from 'Config';

const useStyles = makeStyles({
    dashboardserviceicons: (props) => ({
        padding: '15px',
        width: '100%',
        borderRadius: '3px',
        '&:hover': {
            background: `${props.hoverColor} !important`,
            color: '#fff'
        }
    })
});
const PPIIcon = (props) => {
    const propsInline = { hoverColor: PRIMARY_COLOR() };
    const classesInline = useStyles(propsInline);
    const classes = commonStyle();

    const [colorNonSelected, setColorNonSelected] = useState(
        classes.svg_non_selected
    );
    const [colorSelected, setColorSelected] = useState(classes.svg_selected);

    function MouseOver(event) {
        setColorSelected(classes.svg_white);
        setColorNonSelected(classes.svg_white);
    }
    function MouseOut(event) {
        setColorSelected(classes.svg_selected);
        setColorNonSelected(classes.svg_non_selected);
    }
    return (
        <>
            <div
                className={classesInline.dashboardserviceicons}
                onMouseOver={MouseOver}
                onMouseOut={MouseOut}
            >
                <p>

                    <svg
                        version="1.1"
                        id="Layer_1"
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        viewBox="0 0 512 512"
                        style={{
                            enableBackground: 'new 0 0 512 512',
                            width: '36px'
                        }}
                    >
                        <g>
                            <path
                                className={colorNonSelected}
                                d="M133.4,222.2c0,64,51.9,115.8,115.8,115.8S365,286.1,365,222.2s-51.9-115.8-115.8-115.8  C185.3,106.4,133.4,158.2,133.4,222.2z M249.2,122.3c55.2,0,99.9,44.7,99.9,99.9S304.3,322,249.2,322s-99.9-44.7-99.9-99.9  C149.4,167,194.1,122.4,249.2,122.3z"
                            />

                            <path
                                className={colorNonSelected}
                                d="M404.4,357.7l-62.6,29.6c-8.6-16.1-25.2-26.3-43.5-26.8l-57.8-1.6c-9.1-0.3-18.1-2.6-26.3-6.8l-5.9-3  c-30.1-15.7-66-15.6-96,0.1l0.4-13.3c0.1-4.4-3.4-8.1-7.8-8.2l-63.3-1.7c-4.4-0.1-8.1,3.4-8.2,7.8l-3.8,139  c-0.1,4.4,3.4,8.1,7.8,8.2l63.3,1.7h0.2c4.3,0,7.9-3.4,8-7.8l0.2-6.7l16.5-8.8c6.5-3.5,14-4.3,21.1-2.3l98.3,27.6  c0.2,0.1,0.3,0.1,0.5,0.1c7.1,1.5,14.3,2.2,21.6,2.2c15.4,0,30.6-3.3,44.5-9.7c0.3-0.2,0.7-0.3,1-0.5l142.5-92.2  c3.5-2.3,4.7-7,2.6-10.6C447.1,355.2,423.7,348,404.4,357.7z M45.9,465.1l3.4-123l47.4,1.3l-3.4,123L45.9,465.1z M304.4,463  c-17.4,7.8-36.7,10-55.4,6.2l-98-27.5c-11-3.1-22.8-1.8-32.9,3.6l-8.4,4.5l2.3-81.8c26.6-17.7,60.8-19.5,89.2-4.8l5.9,3  c10.3,5.3,21.6,8.2,33.2,8.6l57.8,1.6c16.2,0.5,30,12,33.3,27.9l-86-2.4c-4.4-0.1-8.1,3.4-8.2,7.8c-0.1,4.4,3.4,8.1,7.8,8.2l95,2.6  h0.2c4.3,0,7.9-3.4,8-7.8c0.1-3.5-0.2-6.9-0.8-10.4l64.2-30.3c0.1,0,0.1-0.1,0.2-0.1c9.1-4.6,20.1-3.1,27.6,3.9L304.4,463z"
                            />

                            <path
                                className={colorNonSelected}
                                d="M257.2,83.9V8c0-4.4-3.6-8-8-8s-8,3.6-8,8v75.9c0,4.4,3.6,8,8,8S257.2,88.3,257.2,83.9z"
                            />
                            <path
                                className={colorNonSelected}
                                d="M317.1,83.9V47.9c0-4.4-3.6-8-8-8c-4.4,0-8,3.6-8,8v35.9c0,4.4,3.6,8,8,8C313.5,91.9,317.1,88.3,317.1,83.9z"
                            />

                            <path
                                className={colorNonSelected}
                                d="M197.3,83.9V47.9c0-4.4-3.6-8-8-8s-8,3.6-8,8v35.9c0,4.4,3.6,8,8,8S197.3,88.3,197.3,83.9z"
                            />

                            <path
                                className={colorNonSelected}
                                class="st0"
                                d="M281.2,188.4v-11.6h-64v11.6h20.4c7.6,0,14,4.9,16.4,11.6h-36.7v11.6h36.7c-1.2,3.4-3.4,6.3-6.3,8.4  c-2.9,2.1-6.4,3.2-10,3.2h-20.4v14l32.5,32.5h16.5L231.2,235h6.3c6.7,0,13.2-2.3,18.4-6.6c5.2-4.2,8.8-10.1,10.1-16.7h15.1v-11.6  h-15.1c-0.9-4.2-2.7-8.2-5.4-11.6H281.2z"
                            />
                        </g>
                    </svg>
                </p>
                <h6>{props.name}</h6>
            </div>
        </>
    );
};

export default PPIIcon;